import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const field = "w-full rounded-xl border border-white/10 bg-ink px-4 py-3 text-paper outline-none transition-colors focus:border-volt";

export const ChangePassword = () => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 8) return setError("Password baru minimal 8 karakter.");
    if (f.next !== f.confirm) return setError("Konfirmasi password tidak sama.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF({ current: "", next: "", confirm: "" });
      toast.success("Password berhasil diganti");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} data-testid="admin-change-password-form" className="space-y-4">
      <input data-testid="admin-cp-current" type="password" required autoComplete="current-password" placeholder="Password sekarang" value={f.current} onChange={set("current")} className={field} />
      <input data-testid="admin-cp-new" type="password" required autoComplete="new-password" placeholder="Password baru (min. 8 karakter)" value={f.next} onChange={set("next")} className={field} />
      <input data-testid="admin-cp-confirm" type="password" required autoComplete="new-password" placeholder="Ulangi password baru" value={f.confirm} onChange={set("confirm")} className={field} />
      {error ? <p data-testid="admin-cp-error" className="text-sm text-red-400">{error}</p> : null}
      <button data-testid="admin-cp-submit" disabled={busy} className="rounded-full bg-volt px-6 py-3 font-semibold text-ink transition-transform hover:scale-[1.03] disabled:opacity-60">{busy ? "Menyimpan…" : "Ganti password"}</button>
    </form>
  );
};
